import * as Yup from "yup";
import useLanguageValidator from "../shared/components/language/validator";
import {
  useAmountValidator,
  useMandatoryStringTypeValidator,
} from "../shared/components/validator";
import { useYesNoValidator } from "../shared/components/validator";
import { useIbanValidator } from "../../ui/widgets/iban/validator";
import { useTextInputValidator } from "../shared/components/formik/text-input/validator";
import { useAddressValidator } from "../shared/components/address-select/validator";
import { useMessageSource } from "react-message-source";
import { useContext } from "react";
import { ProductContext } from "../../context/product-context/productContext";

export default function useGCIValidationSchema() {
  const { getMessage } = useMessageSource();
  const { selectedProduct } = useContext(ProductContext);
  const hasFlexibleInvoicingFeature =
    selectedProduct?.hasFeature("FLEXIBLE_INVOICING");

  const hasDecentralizedInvoicingFeature = selectedProduct?.hasFeature(
    "DECENTRALIZED_INVOICING",
  );

  const addressValidator = useAddressValidator();
  const textInputValidator = useTextInputValidator();

  const fullAddressValidator = Yup.object().shape({
    fullStreet: Yup.string().when(["hasFlexibleInvoicingAddress"], {
      is: (hasFlexibleInvoicingAddress: boolean) =>
        hasFlexibleInvoicingAddress === true,
      then: () => textInputValidator,
    }),
    address: Yup.object().when(["hasFlexibleInvoicingAddress"], {
      is: (hasFlexibleInvoicingAddress: boolean) =>
        hasFlexibleInvoicingAddress === true,
      then: () => addressValidator,
    }),
  });

  const flexibleInvoicingValidator = hasFlexibleInvoicingFeature
    ? {
        flexibleInvoicing: Yup.object().when("hasDecentralizedInvoicing", {
          is: (hasDecentralizedInvoicing: boolean) =>
            hasDecentralizedInvoicing === false,
          then: () => fullAddressValidator,
        }),
      }
    : {};

  return Yup.object().shape({
    limit: useAmountValidator(),
    expectedSpendingPerMonth: useAmountValidator(),
    hasCompanyOnCard: useYesNoValidator(),
    correspondenceLanguage: useLanguageValidator(),
    iban: useIbanValidator(),
    bankName: useMandatoryStringTypeValidator(),
    hasDecentralizedInvoicing: hasDecentralizedInvoicingFeature
      ? Yup.mixed().required(getMessage("Validation.message-required"))
      : null,
    ...flexibleInvoicingValidator,
    decentralizedInvoicingAddress: Yup.string()
      .nullable()
      .when("hasDecentralizedInvoicing", {
        is: true,
        then: () =>
          Yup.string().required(getMessage("Validation.message-required")),
      }),
  });
}
